// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-checklist {
	font-size: 13px;
	color: rgb(141, 141, 141);
}

.password-checklist .match {
	color: rgb(49, 184, 8);
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/password-checklist.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,yBAAyB;AAC1B;;AAEA;CACC,sBAAsB;AACvB","sourcesContent":[".password-checklist {\n\tfont-size: 13px;\n\tcolor: rgb(141, 141, 141);\n}\n\n.password-checklist .match {\n\tcolor: rgb(49, 184, 8);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
